/*global ApeConfig, GtmKey*/

/* Fonts loaded via index.html: Space Grotesk, Rawles, Bricolage Grotesque, Shantell Sans */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App }  from './App';
import { ConfigProvider } from 'antd';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { theme } from 'antd';
import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react'
const projectId = 'dba6f79f78209d89a5dd81e0c7a00d9a'
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const chains = ApeConfig.filter(x => x.Active).map(x => {
	return {
		chainId: x.ID,
		name: x.Name,
		currency: x.NativeToken,
		explorerUrl: x.ScannerUrl,
		rpcUrl: x.PublicRpc,
		auxiliaryFunds: { supported: true }
	}
});

const metadata = {
	name: 'Ape.Store',
	description: 'Ape.Store',
	url: 'https://ape.store',
	icons: ['https://ape.store/img/logo.png']
}

const ethersConfig = defaultConfig({
	metadata,
	enableCoinbase: true,
	rpcUrl: "https://mainnet.base.org",
	defaultChainId: 8453
})

createWeb3Modal({
	ethersConfig,
	chains,
	projectId,
	enableAnalytics: true
})


root.render(
	<BrowserRouter basename={baseUrl}>
		<ConfigProvider theme={{
			token: {
				colorPrimary: '#d6fe52',
				fontFamily: "'Space Grotesk', sans-serif",
				colorLink: '#d6fe52',
				colorText: '#26251f',
				colorTextSecondary: '#4c4a42',
				colorBgBase: '#f4f1e8',
				colorBgContainer: '#fbfaf4',
				colorBorder: '#26251f',
				colorBorderSecondary: '#ddd8c8',
				colorSuccess: '#1fa971',
				colorError: '#e5484d',

				fontSize: 14,

				bgLeftMenu: '#181818',
				bgTopMenu: '#d6fe52',
				bgContent: '#f4f1e8',

				textYellow: '#d6fe52',
				textGreen: '#1fa971',
				textBlue: '#BFDBFE',
				grayd9: '#ddd8c8',
				textGray4e: '#4c4a42',
				textGray74: '#7a776c',
				textGray9c: '#9a978c'
			},
			components: {
				Menu: {
					darkItemSelectedColor: '#fff'
				},
				Button: {
					defaultBorderColor: '#26251f',
					defaultBg: '#d6fe52',
					defaultColor: '#111111',
					borderColorDisabled: '#ddd8c8'
				},
				Collapse: {
					headerPadding: 0,
					contentPadding: 0,
				},
				Input: {
					paddingBlock: '5px',
					paddingInline: '5px',
					colorBgContainer: '#ffffff',
					colorBorder: '#26251f'
				},
				Card: {
					headerHeight: '36px',
					headerBg: '#d6fe52',
					colorBgContainer: '#fbfaf4',
					colorHeaderBg: '#d6fe52'
				},
				Table: {
					headerBg: '#fbfaf4',
					headerColor: '#26251f',
					colorBgContainer: '#fbfaf4',
				},
				InputNumber: {
					paddingBlock: '2px',
					lineHeight: '26px'
				},
				Slider: {
					handleLineWidth: '1px',
					handleColor: 'transparent',
					handleActiveColor: 'transparent',
					handleSize: '20px',
					handleSizeHover: '20px',
					railSize: '10px'
				},
				Tabs: {
					itemColor: '#26251f',
					itemSelectedColor: '#111111',
					inkBarColor: '#d6fe52',
				},
				Radio: {
					defaultBorderColor: '#26251f',
					buttonCheckedBg: '#d6fe52'
				}
			}
		}}>
			<App />
		</ConfigProvider>
	</BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
